import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { staggerRevealOnScroll } from '../../utils/animations';
import styles from './Process.module.scss';

const processSteps = [
  { title: 'Discovery', description: 'Understanding your business goals and market.' },
  { title: 'Research', description: 'Deep-dive into keywords, competitors, and technical audits.' },
  { title: 'Strategy', description: 'Formulating a custom roadmap for sustainable growth.' },
  { title: 'Execution', description: 'Implementing technical fixes, content, and link building.' },
  { title: 'Growth', description: 'Monitoring, refining, and scaling the results.' }
];

const Process: React.FC = () => {
  const timelineRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      staggerRevealOnScroll(timelineRef.current, `.${styles.step}`);
    });
    return () => ctx.revert();
  }, []);

  return (
    <section className={styles.processSection} id="process">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.sectionTitle}>The <span className={styles.highlight}>Process</span></h2>
          <p className={styles.sectionSubtitle}>A systematic approach to predictable results.</p>
        </div>

        <div ref={timelineRef} className={styles.timeline}>
          {processSteps.map((step, index) => (
            <div key={index} className={styles.step}>
              <div className={styles.stepMarker}>
                <div className={styles.innerDot}></div>
              </div>
              <div className={styles.stepContent}>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
